const tableHeaders = [
  {
    label: 'dealer-code',
    key: 'entity',
    sortable: false,
  },
  {
    label: 'dealer-name',
    key: 'dealerName',
    sortable: false,
  },
  {
    label: 'BC',
    key: 'bc',
    sortable: false,
  },
  {
    label: 'sales-district',
    key: 'salesDistrict',
    sortable: false,
  },
  {
    label: 'service-district',
    key: 'serviceDistrict',
    sortable: false,
  },
  {
    label: 'form-layout',
    key: 'layout',
    sortable: false,
  },
  {
    label: 'form-name',
    key: 'configName',
    sortable: false,
  },
  {
    label: 'level',
    key: 'mostRecentStepName',
    sortable: false,
  },
  {
    label: 'status',
    key: 'overallStatus',
    sortable: false,
  },
  {
    label: 'date',
    filter: 'date',
    key: 'mostRecentStatusCreatedAt',
    sortable: false,
  },
  {
    label: 'view',
    key: 'view',
    sortable: false,
  },
];

export default () => tableHeaders;
